import { PER_PAGE_OPTIONS } from '@library/constants/common';
import { Select } from '@library/components/selects';
import type { SelectOption } from '@library/types/utils';

interface RowsPerPageProps {
  handleSelectPerPage: (value: SelectOption<string>) => void;
  offset?: number;
  perPageOptions?: Array<SelectOption<string>>;
  placement?: 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end';
  selectedPerPage: string;
}

const RowsPerPage = ({
  handleSelectPerPage,
  offset = 0,
  perPageOptions = PER_PAGE_OPTIONS,
  placement = 'bottom-start',
  selectedPerPage
}: RowsPerPageProps) => {
  return (
    <div className="flex items-center gap-4 py-3">
      <span className="text-soClean-100 self-center text-sm">
        Rows Per Page:
      </span>
      <Select
        offset={offset}
        onChange={handleSelectPerPage}
        options={perPageOptions}
        placement={placement}
        label="Per Page"
        size="small"
        value={selectedPerPage}
        testId="scoring-rows-per-page"
      />
    </div>
  );
};
export default RowsPerPage;
